import {
  Backdrop, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Container, Dialog,
  DialogActions, DialogContent, DialogTitle, Divider, Grid, LinearProgress,
  Select, Slide, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField,
  Typography, Input, Slider
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SendIcon from '@material-ui/icons/Send';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { CustomTableCell } from 'src/components/CustomTableCell';
import GenericBulten from 'src/components/GenericBulletin';
import Page from 'src/components/Page';
import AddressSearch from 'src/components/Selects/AddressSearch';
import MaterialSearch from 'src/components/Selects/MaterialSearch';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import LockIcon from '@material-ui/icons/Lock';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, getUser, GetWarehouseAddress, setSepetAdet, getSepetAdet } from 'src/utils/Common';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  container: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  containerIc: {
    width: '100%',
    overflowX: 'auto',
  },
  containersag: {
    width: '100%',
    maxHeight: 476,
    minHeight: 476,
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },

}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Sale() {
  const classes = useStyles();
  const [customer, setCustomer] = useState('');
  const [description, setDescription] = useState('');
  const [material, setMaterial] = useState('');
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowIndex, setRowIndex] = useState(0);
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [MalzemeSiparis, setMalzemeSiparis] = React.useState('');
  const [SiparisAdetTitle, setSiparisAdetTitle] = React.useState('');
  const [openSiparisAdet, setopenSiparisAdet] = React.useState(false);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [siparisAdet, setsiparisAdet] = React.useState(1);
  const [LoadingMaterial, setLoadingMaterial] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [ImageUrl, setImageUrl] = useState(null);
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState("");
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [data, setData] = useState({});
  const SessionUser = getUser();


  useEffect(() => {
    CreateWareHouseAddress(SessionUser.ServiceShopId);
    var DegerWarehouseAddress = [];
    DegerWarehouseAddress = GetWarehouseAddress(SessionUser.ServiceShopId);
    setWarehouseAddress(DegerWarehouseAddress);
  }, []);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  var DepoAdet = 0;
  var KdvliFiyat = 0;
  const addSaleRows = (newPage) => {
    axios.get(`GetDepoAdetFiyat/${newPage.data.materialCode}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`)
      .then(response => {
        DepoAdet = response.data.split('|')[0];
        KdvliFiyat = response.data.split('|')[1];
        var ADRES_ADET = response.data.split('|')[2];
        var WarehouseAddressText = response.data.split('|')[3];
        var WarehouseAddress = response.data.split('|')[4];
        var varMi = rows.filter(d => d.MaterialCode.replace(/^0+/, '') === newPage.data.materialCode);
        if (varMi.length > 0) {
          var filteredRowIndex = rows.findIndex(d => d.MaterialCode.replace(/^0+/, '') === newPage.data.materialCode);
          rows.splice(filteredRowIndex, 1);
          varMi[0].Count = parseInt(varMi[0].Count) + 1;
          varMi[0].DEPO_ADET = DepoAdet;
          varMi[0].KDVLIFIYAT = KdvliFiyat;
          varMi[0].ADRES_ADET = ADRES_ADET;
          varMi[0].WarehouseAddressText = WarehouseAddressText;
          varMi[0].WarehouseAddress = WarehouseAddress;
          let DegerOld = [...rows, varMi[0]];
          setRows(DegerOld);
        } else {
          setRowIndex(rowIndex + 1);
          let row = {
            index: rowIndex, Customer: newPage.customer,
            Description: newPage.description, MaterialCode: newPage.data.materialCode,
            MaterialDesc: newPage.data.materialDesc, MaterialId: newPage.data.materialId,
            Count: 0,
            DEPO_ADET: DepoAdet,
            ADRES_ADET: ADRES_ADET,
            WarehouseAddressText: WarehouseAddressText,
            WarehouseAddress: WarehouseAddress,
            KDVLIFIYAT: KdvliFiyat
          };
          setRows([...rows, row]);
        }
      }).catch(error => {
        DepoAdet = 0;
        KdvliFiyat = 0;
      })

  };
  const onChange = (e, row) => {
    var value = e.target.value;
    const name = e.target.name;
    if (parseInt(value) < 0) {
      value = 1;
    }
    const { index } = row;
    const newRows = rows.map(row => {
      if (row.index === index) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const handleChangeMaterial = (material) => {
    if (material != undefined) {
      let old_rows = { materialId: material.MaterialId, materialCode: material.MaterialCode, materialDesc: material.MaterialDesc };
      setData(old_rows);
    }
  }
  const GetMaterialImage = (materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + " Numaralı Malzeme Detayı");
    axios.get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      }).catch(error => {
        setLoadingMaterial(false);
      });
  }
  const GetMaterialBulletin = (materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
  }

  const SetMalzemeCikar = (rowIndex) => {
    confirmAlert({
      message: "Malzeme satış listesinden çıkartılacaktır!... Devam etmek istediğinizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => { SetMalzemeCikarKabul(rowIndex); }
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  }
  const SetMalzemeCikarKabul = (index) => {
    var rowsYedek = [...rows];
    rowsYedek.splice(index, 1);
    setRows(rowsYedek);
  }
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const saveExits = () => {

    var Varmi = rows.filter(d => parseInt(d.Count) < 1);
    var VarmiAdres = rows.filter(d => d.WarehouseAddress === undefined);


    const KontrolAdet = rows.filter(d => parseInt(d.Count) > parseInt(d.ADRES_ADET));

    if (KontrolAdet.length > 0) {
      setUyariTip('error');
      setUyariAciklama("Çıkış yapılmaya çalışılan malzeme adedi depo adres adedinden fazla lütfen kontrol ediniz!...");
      setUyari(true);
      return;
    }





    if (Varmi.length > 0) {
      setUyariTip('error');
      setUyariAciklama("Satış adedi girilmedi!..Lütfen kontrol ediniz!...");
      setUyari(true);
      return;
    }
    if (VarmiAdres.length > 0) {
      setUyariTip('error');
      setUyariAciklama("Malzeme adresi girilmedi!..Lütfen kontrol ediniz!...");
      setUyari(true);
      return;
    }
    let data = [];
    rows.forEach(m => {
      data = [...data, {
        BIRIM_KODU: SessionUser.ServiceShopId,
        MALZEME_KODU: m.MaterialId,
        DEPO_ADRES_ID: m.WarehouseAddress,
        CIKIS_TIPI: 3,
        ADET: m.Count,
        CIKIS_YAPILAN: m.Customer + '-' + m.Description,
        KULLANICI: SessionUser.TechnicianId,
        TAHSILAT_TIPI: m.TAHSILAT_TIPI || 1,
      }]
    });
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true);
    axios.post('/SetStockExit', data, config)
      .then(response => {
        setLoading(false);
        setUyariTip('success');
        let ResponseData = response.data[0];
        if (parseInt(ResponseData.ErrorCode) === 0) {
          setUyariTip('success');
          setUyariAciklama(ResponseData.ErrorDescription);
          setUyari(true);
          setRows([]);
          setCustomer("");
          setDescription("");
          setData({});
        } else {
          setUyariTip('error');
          setUyariAciklama(ResponseData.ErrorDescription);
          setUyari(true);
        }

      }).catch(error => {
        setLoading(false);
      });
  };

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {
    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${SessionUser.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {
        let old_rows = [...rows];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setRows(old_rows);
      })
      .catch(error => {
        console.log(error);
      });
  }
  const handleChangeTahsilat = (e, index) => {
    let old_rows = [...rows];
    old_rows[index].TahsilatTipi = e.target.value;
    setRows(old_rows);
  }

  const SepeteEkle = (event, MALZEME_STOK_NO) => {
    setMalzemeSiparis(MALZEME_STOK_NO);
    setSiparisAdetTitle(
      MALZEME_STOK_NO +
      ' numaralı malzeme sipariş verebilmeniz için sepete eklenecektir!... Devam etmek istediğinizden emin misiniz?'
    );
    setopenSiparisAdet(true);
  };

  const handleCloseSiparisAdet = () => {
    setopenSiparisAdet(false);
    setsiparisAdet(1);
  };

  const SepeteEkleDetay = event => {
    setLoading(true);
    const data = {
      MALZEME_STOK_NO: MalzemeSiparis,
      BIRIM_KODU: SessionUser.ServiceShopId,
      TEKNISYEN_KODU: SessionUser.OrganizationUserId,
      ADET: siparisAdet
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetMaterialBasket', data, config)
      .then(response => {
        if (response.data[0].ErrorCode === '0') {
          var Deger = getSepetAdet();
          setSepetAdet(parseInt(Deger) + 1);
          setUyariTip('success');
          setUyariAciklama('İşlem başarılı');
          setUyari(true);

        } else {
          setUyariTip('error');
          setUyariAciklama(response.data[0].ErrorDescription);
          setUyari(true);
        }
        setLoading(false);
        setopenSiparisAdet(false);
        setsiparisAdet(1);
      })
      .catch(error => {
        setUyariTip('error');
        setUyariAciklama('Bir hata oluştu!..' + error.message);
        setUyari(true);
        setLoading(false);
      });
  };

  const handleBlur = () => {
    if (siparisAdet < 0) {
      setsiparisAdet(0);
    } else if (siparisAdet > 999) {
      setsiparisAdet(999);
    }
  };

  const handleInputChange = event => {
    setsiparisAdet(event.target.value === '' ? '' : Number(event.target.value));
    if (Number(event.target.value) < 0) {
      setsiparisAdet(0);
    } else if (Number(event.target.value) > 999) {
      setsiparisAdet(999);
    }
  };

  const handleSliderChange = (event, newValue) => {
    setsiparisAdet(newValue);
    if (Number(newValue) < 0) {
      setsiparisAdet(0);
    } else if (Number(newValue) > 999) {
      setsiparisAdet(999);
    }
  };


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Stok Çıkışı - Elden Satış" />
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={3}>
                <Card className={classes.container}>
                  <CardHeader title="Giriş" />
                  <Divider />
                  <CardContent>
                    <TextField
                      label="Müşteri Bilgileri"
                      value={customer}
                      variant="outlined"
                      onChange={event => { setCustomer(event.target.value) }}
                      fullWidth
                    />
                    <br /><br />
                    <TextField
                      label="Açıklama"
                      rows={8}
                      multiline={true}
                      variant="outlined"
                      value={description}
                      onChange={event => { setDescription(event.target.value) }}
                      fullWidth
                    />
                    <br /><br />
                    <MaterialSearch
                      label={"Malzeme"}
                      value={{
                        MaterialId: data.materialId,
                        MaterialCode: data.materialCode,
                        MaterialDesc: data.materialDesc
                      }}
                      setValue={(material) => handleChangeMaterial(material)}
                      showHelper={true}
                    />
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      endIcon={<AddCircleOutlineIcon></AddCircleOutlineIcon>}
                      onClick={() => addSaleRows({ customer, description, data })}
                    >
                      Ekle
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Card className={classes.containersag}>
                  <CardHeader
                    title="İşlemler"
                    action={
                      <Button
                        variant="contained"
                        className={classes.button}
                        color="secondary"
                        endIcon={<SendIcon></SendIcon>}
                        onClick={() => saveExits()}
                      >
                        Çıkış Yap
                      </Button>
                    }
                  />
                  <Divider />
                  <CardContent>
                    <TableContainer className={classes.containerIc}>
                      <Table
                        className={classes.table}
                        size="small"
                        stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell padding='none' align="left">Alıcı</TableCell>
                            <TableCell padding='none' align="left">Açıklama</TableCell>
                            <TableCell padding='none' align="left">MalzemeStokNo</TableCell>
                            <TableCell padding='none' align="left">Malzeme</TableCell>
                            <TableCell padding='none' align="left">KdvliFiyat</TableCell>
                            <TableCell padding='none' align="left">DepoAdet</TableCell>
                            <TableCell padding='none' align="left">AdresAdet</TableCell>
                            <TableCell padding='none' align="center">SatılanAdet</TableCell>
                            <TableCell padding='none' align="center" width="200">Adres</TableCell>
                            <TableCell padding='none' align="center" width="200">Tahsilat</TableCell>
                            <TableCell padding='none' align="center">Sipariş</TableCell>
                            <TableCell padding='none' align="center">Resim</TableCell>
                            <TableCell padding='none' align="center">Bülten</TableCell>
                            <TableCell padding='none' align="center">Sil</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell padding='none' align="left" className={classes.tableCell}>
                                {row.Customer}
                              </TableCell>
                              <TableCell padding='none' align="left" className={classes.tableCell}>
                                {(row.Description.length) > 20 ? row.Description.substring(0, 20) + '...' : row.Description}
                              </TableCell>
                              <TableCell padding='none' align="left" className={classes.tableCell}>
                                {row.MaterialCode.replace(/^0+/, '')}
                              </TableCell>
                              <TableCell padding='none' align="left" title={row.MaterialDesc} className={classes.tableCell}>
                                {(row.MaterialDesc.length) > 20 ? row.MaterialDesc.substring(0, 20) + '...' : row.MaterialDesc}
                              </TableCell>
                              <TableCell padding='none' align="left" title={row.MaterialDesc} className={classes.tableCell}>
                                {row.KDVLIFIYAT + " ₺"}
                              </TableCell>
                              <TableCell
                                align="left"
                                padding='none'
                                className={classes.tableCell}
                              >
                                {parseInt(row.DEPO_ADET) > 0 ? (
                                  parseInt(row.DEPO_ADET, 10)
                                ) : (
                                  <b style={{ color: 'red' }}>
                                    {parseInt(row.DEPO_ADET, 10)}
                                  </b>
                                )}
                              </TableCell>
                              <TableCell
                                align="left"
                                padding='none'
                                className={classes.tableCell}
                              >
                                {parseInt(row.ADRES_ADET) > 0 ? (
                                  parseInt(row.ADRES_ADET, 10)
                                ) : (
                                  <b style={{ color: 'red' }}>
                                    {parseInt(row.ADRES_ADET, 10)}
                                  </b>
                                )}
                              </TableCell>
                              <CustomTableCell {...{ row, name: "Count", onChange, Adet: row.ADRES_ADET }} />

                              <TableCell padding='none' align="center">
                                {
                                  row.DEPO_ADET > 0 ?
                                    <AddressSearch
                                      setAdres={setAdres}
                                      value={{
                                        Id: row.WarehouseAddress || '0',
                                        Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                                        Materials: row.Malzemeleri | ''
                                      } || ''}
                                      searchParam={search}
                                      MaterialCode={row.MaterialCode.replace(/^0+/, '')}
                                      ServicePaperNr={0}
                                      index={index}
                                      Adres={row.WarehouseAddress || 0}
                                      RowSelected={1}
                                      Tip={"Cikis1"}
                                    />
                                    :
                                    <TextField
                                      type="text"
                                      disabled
                                      value={"Malzeme Adresi Bulunmuyor!.."}
                                      fullWidth
                                    />
                                }
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                <Select
                                  native
                                  style={{ width: 100 }}
                                  // value={state.age}
                                  onChange={e => handleChangeTahsilat(e, index)}
                                >
                                  <option value={1}>Nakit</option>
                                  <option value={2}>Kredi kartı</option>
                                  <option value={3}>Senet</option>
                                  <option value={4}>Borç</option>
                                  <option value={5}>Diğer</option>
                                </Select>
                              </TableCell>
                              <TableCell
                                align="center"
                                padding='none'
                                className={classes.tableCell}
                              >
                                {row.SIP_VERILEBILIR === 0 ?
                                  <LockIcon color="error" />
                                  :
                                  <AddShoppingCartIcon
                                    onClick={(event) => SepeteEkle(event, row.MaterialCode)}
                                    color="primary"
                                  />
                                }

                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                <ImageSearchIcon
                                  onClick={() => GetMaterialImage(row.MaterialCode.replace(/^0+/, ''))}
                                  color="primary" />
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                <FindInPageIcon
                                  onClick={() => GetMaterialBulletin(row.MaterialCode.replace(/^0+/, ''))}
                                  color="primary" />
                              </TableCell>
                              <TableCell padding='none' align="center" className={classes.tableCell}>
                                <DeleteForeverIcon
                                  onClick={() => SetMalzemeCikar(index)}
                                  color="error" />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler</DialogTitle>
        <DialogContent>
          {LoadingMaterial ? <LinearProgress
            status="loading"
          /> : <GenericBulten param={bultenParam} />}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => { setBultenOpen(false); }}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        // TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}      >
        <DialogTitle>
          {openMaterialFileTitle}
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? <LinearProgress
            status="loading"
          /> : <img style={{ width: '100%' }} alt='' src={ImageUrl} />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSiparisAdet}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseSiparisAdet}
      >
        <DialogTitle>{SiparisAdetTitle}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Typography id="input-slider" gutterBottom>
              Sipariş Adet
            </Typography>
            <Grid item xs={12} sm={12}>
              <Slider
                value={typeof siparisAdet === 'number' ? siparisAdet : 0}
                onChange={handleSliderChange}
                aria-labelledby="input-slider"
                max={999}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <Input
                className={classes.input}
                value={siparisAdet}
                margin="dense"
                fullWidth
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                  step: 10,
                  min: 0,
                  max: 100,
                  type: 'number',
                  'aria-labelledby': 'input-slider'
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={SepeteEkleDetay} color="primary">
            Ekle
          </Button>
          <Button onClick={handleCloseSiparisAdet} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>


    </Page>
  );
}

export default Sale;
